var React = require('react');

function Fleche (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 4.266 4.821 C 4.2 4.891 4.101 4.926 3.97 4.926 C 3.856 4.926 3.764 4.891 3.699 4.821 L 0.024 0.192 C 0.009 0.192 0 0.176 0 0.139 C 0 0.103 0.021 0.07 0.061 0.035 C 0.103 -0 0.131 -0.009 0.149 0.009 L 3.97 3.2 L 7.793 0.009 C 7.826 -0.008 7.871 0.014 7.929 0.074 C 7.986 0.135 7.99 0.174 7.941 0.192 Z","fill":"rgb(56, 56, 56)"}));
}

Fleche.defaultProps = {"width":"8","height":"5"};

module.exports = Fleche;

Fleche.default = Fleche;
